/* eslint-disable no-shadow */
import axios from "axios";
import {
  createOnRequest,
  onResponseSuccess,
  onResponseError,
} from "./api-client-helper";
export enum AuthTokenType {
  IdToken,
  AccessToken,
  AppOrUserAccessToken,
}

const createAuthorizedApiClient = (
  baseURL: string,
  authTokenType: AuthTokenType,
  withOrgToken: boolean = false
) => {
  const instance = axios.create({
    baseURL,
  });

  instance.interceptors.request.use(
    createOnRequest(authTokenType, withOrgToken)
  );
  instance.interceptors.response.use(onResponseSuccess, onResponseError);

  return instance;
};

export default createAuthorizedApiClient;
